import { render, staticRenderFns } from "./Process3.vue?vue&type=template&id=27af153a&scoped=true"
import script from "./Process3.vue?vue&type=script&lang=js"
export * from "./Process3.vue?vue&type=script&lang=js"
import style0 from "./Process3.vue?vue&type=style&index=0&id=27af153a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27af153a",
  null
  
)

export default component.exports